import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import BodyText from 'LuxKit/Typography/BodyText'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  inclusions: Array<App.PackageInclusion>
}

export function HotelSummaryInclusions({ inclusions }: Props) {
  const intl = useIntl()
  const bonusInclusions = inclusions.filter(inclusion => inclusion.isBonus)
  const regularInclusions = inclusions.filter(inclusion => !inclusion.isBonus)

  return (
    <VerticalSpacer gap={12}>
      {regularInclusions && regularInclusions.length > 0 && (
        <div>
          <BodyText variant="medium" weight="bold">
            <FormattedMessage
              id="7TkY0OrBDIS8K1W86dK-"
              defaultMessage="Package inclusions:"
              description="Label for the list of items included in the hotel package"
            />
          </BodyText>
          {regularInclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} isHighlighted={inclusion.isHighlighted} />)}
        </div>
      )}
      {bonusInclusions && bonusInclusions.length > 0 && (
        <div>
          <BodyText variant="medium" weight="bold" format="propercase">{intl.formatMessage({
            id: 'QHEyfbSSWAYmH81kVqvg',
            defaultMessage: 'Extra inclusions:',
            description: 'Label for bonus inclusions list in hotel summary inclusions section',
          })}
          </BodyText>
          {bonusInclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} />)}
        </div>
      )}
    </VerticalSpacer>
  )
}
